"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SALES_1_1_VIDEO_CREATION", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_1_1_VIDEO_CREATION;
  }
});
Object.defineProperty(exports, "SALES_CALCULATED_PROPERTIES", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_CALCULATED_PROPERTIES;
  }
});
Object.defineProperty(exports, "SALES_CALL_TRANSCRIPTION_REPORTING", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_CALL_TRANSCRIPTION_REPORTING;
  }
});
Object.defineProperty(exports, "SALES_CALLING", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_CALLING;
  }
});
Object.defineProperty(exports, "SALES_CANNED_SNIPPETS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_CANNED_SNIPPETS;
  }
});
Object.defineProperty(exports, "SALES_COMPANY_RECORDS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_COMPANY_RECORDS;
  }
});
Object.defineProperty(exports, "SALES_CONTACT_COMPANY_INSIGHTS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_CONTACT_COMPANY_INSIGHTS;
  }
});
Object.defineProperty(exports, "SALES_CONTACT_MANAGEMENT", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_CONTACT_MANAGEMENT;
  }
});
Object.defineProperty(exports, "SALES_CONVERSATION_ROUTING", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_CONVERSATION_ROUTING;
  }
});
Object.defineProperty(exports, "SALES_CONVERSATIONAL_BOTS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_CONVERSATIONAL_BOTS;
  }
});
Object.defineProperty(exports, "SALES_CONVERSATIONS_INBOX", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_CONVERSATIONS_INBOX;
  }
});
Object.defineProperty(exports, "SALES_CUSTOM_REPORTING", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_CUSTOM_REPORTING;
  }
});
Object.defineProperty(exports, "SALES_DEALS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_DEALS;
  }
});
Object.defineProperty(exports, "SALES_DOCUMENTS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_DOCUMENTS;
  }
});
Object.defineProperty(exports, "SALES_EMAIL_SCHEDULING", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_EMAIL_SCHEDULING;
  }
});
Object.defineProperty(exports, "SALES_EMAIL_SEQUENCES", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_EMAIL_SEQUENCES;
  }
});
Object.defineProperty(exports, "SALES_EMAIL_TEMPLATES", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_EMAIL_TEMPLATES;
  }
});
Object.defineProperty(exports, "SALES_EMAIL_TRACKING_NOTIFICATIONS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_EMAIL_TRACKING_NOTIFICATIONS;
  }
});
Object.defineProperty(exports, "SALES_ESIGNATURE", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_ESIGNATURE;
  }
});
Object.defineProperty(exports, "SALES_GMAIL_AND_OUTLOOK_INTEGRATION", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_GMAIL_AND_OUTLOOK_INTEGRATION;
  }
});
Object.defineProperty(exports, "SALES_GOALS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_GOALS;
  }
});
Object.defineProperty(exports, "SALES_HUBSPOT_BRANDING_REMOVED", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_HUBSPOT_BRANDING_REMOVED;
  }
});
Object.defineProperty(exports, "SALES_LIVE_CHAT", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_LIVE_CHAT;
  }
});
Object.defineProperty(exports, "SALES_MEETING_SCHEDULING", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_MEETING_SCHEDULING;
  }
});
Object.defineProperty(exports, "SALES_MULTIPLE_CURRENCIES", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_MULTIPLE_CURRENCIES;
  }
});
Object.defineProperty(exports, "SALES_MULTIPLE_DEAL_PIPELINES", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_MULTIPLE_DEAL_PIPELINES;
  }
});
Object.defineProperty(exports, "SALES_PHONE_SUPPORT", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_PHONE_SUPPORT;
  }
});
Object.defineProperty(exports, "SALES_PLAYBOOKS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_PLAYBOOKS;
  }
});
Object.defineProperty(exports, "SALES_PREDICTIVE_LEAD_SCORING", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_PREDICTIVE_LEAD_SCORING;
  }
});
Object.defineProperty(exports, "SALES_PRODUCTS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_PRODUCTS;
  }
});
Object.defineProperty(exports, "SALES_PROSPECTS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_PROSPECTS;
  }
});
Object.defineProperty(exports, "SALES_QUOTE_APPROVALS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_QUOTE_APPROVALS;
  }
});
Object.defineProperty(exports, "SALES_QUOTES", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_QUOTES;
  }
});
Object.defineProperty(exports, "SALES_RECURRING_REVENUE_TRACKING", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_RECURRING_REVENUE_TRACKING;
  }
});
Object.defineProperty(exports, "SALES_REPORTING_DASHBOARDS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_REPORTING_DASHBOARDS;
  }
});
Object.defineProperty(exports, "SALES_REQUIRED_FIELDS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_REQUIRED_FIELDS;
  }
});
Object.defineProperty(exports, "SALES_SALES_AUTOMATION", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_SALES_AUTOMATION;
  }
});
Object.defineProperty(exports, "SALES_SALESFORCE_INTEGRATION", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_SALESFORCE_INTEGRATION;
  }
});
Object.defineProperty(exports, "SALES_SINGLE_SIGN_ON", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_SINGLE_SIGN_ON;
  }
});
Object.defineProperty(exports, "SALES_SMART_NOTIFICATIONS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_SMART_NOTIFICATIONS;
  }
});
Object.defineProperty(exports, "SALES_SMART_SEND_TIMES", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_SMART_SEND_TIMES;
  }
});
Object.defineProperty(exports, "SALES_TASKS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_TASKS;
  }
});
Object.defineProperty(exports, "SALES_TEAM_EMAIL", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_TEAM_EMAIL;
  }
});
Object.defineProperty(exports, "SALES_TEAMS", {
  enumerable: true,
  get: function get() {
    return _HubSpotFeature.SALES_TEAMS;
  }
});

var _HubSpotFeature = require("../HubSpotFeature");


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/groupTags/hubspotFeatures/Sales.js
// module id = 723
// module chunks = 209 210 211 212